"use client";

import { setTag, setUser } from "@sentry/nextjs";
import { useEffect } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { resolveSentryUserContext } from "./sentryUserContext.utils";
export function SentryUserProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    user
  } = useCurrentUser();
  useEffect(() => {
    const {
      user: sentryUser,
      orgId
    } = resolveSentryUserContext({
      user: user ? {
        id: user.id,
        email: user.email
      } : undefined,
      orgId: user?.sessionOrgId
    });
    if (sentryUser) {
      setUser(sentryUser);
      if (orgId) setTag("orgId", orgId);
    } else {
      setUser(null);
      setTag("orgId", undefined);
    }
  }, [user?.id, user?.email, user?.sessionOrgId]);
  return <>{children}</>;
}